export default "/images/vendor/flag-icons/flags/4x3/es-ct.svg?ae2d1ab93385b37fd124bbad96005ac8";